/**
 * Get the stats necessary for rendering various computed cell values in the ConfirmChannelsTable.
 * @param gapChannels - the table data; an array of {@link TrqkGapChannel} objects
 * @returns - {@link GapChannelStats}
 */
export const getGapChannelStats = (
    gapChannels: TrqkGapChannel[],
): GapChannelStats => {
    let detectionsMax = 0;
    let performancesMax = 0;

    gapChannels.forEach((gapChannel: TrqkGapChannel): void => {
        const audiosDetected = gapChannel?.detections_included ?? 0;

        if (audiosDetected > detectionsMax) {
            detectionsMax = audiosDetected;
        }

        const performancesMatchedTotal =
            gapChannel?.performances_matched_total ?? 0;

        if (performancesMatchedTotal > performancesMax) {
            performancesMax = performancesMatchedTotal;
        }
    });

    return {
        detectionsMax,
        performancesMax,
    };
};
